import { t } from 'i18next'

import { formatMoney } from '~/helpers'
import { primary as theme } from '~/styles/themes'

import {
  abbreviateCurrency,
  formatCompareMetricLabel,
  formatStylesChart,
  maxValue
} from '../../helpers'
import { CreateDataset } from '../types'
import { OptionsScale } from './types'

const axisID = 'y-balance'

const settings = {
  label: t('rm:balanceInWallet'),
  formatData: (value: number) => abbreviateCurrency(value),
  formatAdditionalData: (value: number) => formatMoney(value),
  color: theme.colors.infoLighten20,
  dataKey: 'balance' as keyof (
    | ReportHistoryCampaigns
    | ReportHistoryCampaignsRealtime
  ),
  order: 80
}

const dataset: CreateDataset = ({ data, isCompare = false }) => ({
  yAxisID: isCompare ? `${axisID}-compare` : axisID,
  type: 'line',
  label: formatCompareMetricLabel({ label: settings.label, isCompare }),
  data: data?.[settings.dataKey] || null,
  order: isCompare ? settings.order - 1 : settings.order,

  ...formatStylesChart({ color: settings.color, isCompare })
})

const optionsScale: OptionsScale = ({
  selectedMetrics,
  showScaleRuler = true,
  drawOnChartArea = true,
  position = 'left',
  data,
  isCompare = false
}) => {
  const shouldApplyMax =
    selectedMetrics?.includes('income') ||
    selectedMetrics?.includes('totalSpent')

  return {
    [isCompare ? `${axisID}-compare` : axisID]: {
      display: showScaleRuler,
      grid: {
        // If true, draw lines on the chart area inside the axis lines. This is useful
        // when there are multiple axes and you need to control which grid lines are drawn.
        drawOnChartArea
      },
      position,
      suggestedMin: 0,
      suggestedMax: shouldApplyMax ? maxValue({ data })?.money : null,
      beginAtZero: true,
      ticks: {
        z: -1,
        color: settings.color,
        callback: settings.formatData
      }
    }
  }
}

const totalSpentPreset = { axisID, dataset, optionsScale, settings }

export default totalSpentPreset
